export default "__VITE_ASSET__CEEKr4ym__"